<micro-lookup domain="auth" obj="contactDepartments" url="/contactDepartments" [key]="contactDepartmentId" [link]="link"></micro-lookup>
